import {
  getAuditDetails,
  getAuditFieldInfo,
  AuditService,
  AuditActionType,
} from 'shared/userAudit/audit-constants';
import { Operation, AuditDetails } from 'data/types';
import { NetworkId } from 'data/networkId/networkId.types';

// eslint-disable-next-line import/prefer-default-export
export function getAuditDetailsToSubmit(
  dialedDigitExtractionServerData: NetworkId,
  originalDigitExtractionServerFormData: NetworkId | null,
  isAuditEnabled: boolean,
  userId: string,
  userName: string,
  operation: Operation,
): AuditDetails {

  let actionType = AuditActionType.NETWORK_ADD;
  let isEdit = false;
  if (operation === 'UPDATE') {
    actionType = AuditActionType.NETWORK_EDIT;
    isEdit = true;
  }

  const auditDetails = getAuditDetails(
    isAuditEnabled,
    userId,
    userName,
    getAuditFieldInfo(dialedDigitExtractionServerData, null, isEdit, originalDigitExtractionServerFormData),
    dialedDigitExtractionServerData.networkId,
    AuditService.NETWORK,
    actionType,
  );
  return auditDetails as AuditDetails;
}
